import type { ReactNode } from "react";

/** Key/value pairs on a record detail page. */
export function DefinitionList({ items }: {
  items: { label: ReactNode; value: ReactNode; numeric?: boolean }[];
}) {
  return (
    <dl className="deflist">
      {items.map((it, i) => (
        <div key={i} style={{ display: "contents" }}>
          <dt>{it.label}</dt>
          <dd className={it.numeric ? "num" : undefined}>{it.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export type FeedEntry = { meta: ReactNode; body: ReactNode; tone?: "pos" | "warn" | "neg" };

/** Interaction history, audit trail, activity log. */
export function ActivityFeed({ entries }: { entries: FeedEntry[] }) {
  return (
    <div className="feed">
      {entries.map((e, i) => (
        <div className="feed-item" key={i}>
          <div className="feed-rail">
            <span className="feed-dot"
                  style={e.tone ? { background: `var(--${e.tone})` } : undefined} />
            {i < entries.length - 1 && <span className="feed-line" />}
          </div>
          <div className="feed-body">
            <div className="feed-meta">{e.meta}</div>
            <div className="feed-text">{e.body}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
